import { supabase } from '../supabaseClient';

export class ClientService {
  // Convert a wizard submission into a Client (via Supabase RPC)
  static async convertSubmissionToClient(submissionId, forceRefresh = false) {
    try {
      const { data, error } = await supabase.rpc('admin_sync_client_from_submission', {
        p_submission_id: submissionId,
        p_force_refresh: !!forceRefresh
      });
      if (error) throw error;

      const payload = data || {};
      if (payload?.client_id) {
        const email = payload?.client?.primary_email || payload?.client?.email || payload?.client?.email_address;
        try {
          await ClientService.ensureClientPortalUser(payload.client_id, email);
        } catch (portalError) {
          console.error('Client portal provisioning failed', portalError);
          // Don't fail the whole conversion if portal fails, but log it
          // We could also try to bubble this up if critical
        }
      }

      return payload;
    } catch (error) {
      console.error('Error converting submission to client:', error);
      throw error;
    }
  }

  static async ensureClientPortalUser(clientId, email, password) {
    if (!clientId) throw new Error('Client ID is required');
    try {
      const { data, error } = await supabase.functions.invoke('client-portal-user', {
        body: {
          action: 'ensure',
          clientId,
          email,
          password: password || undefined
        }
      });

      if (error) {
        console.error('ensureClientPortalUser invoke error', error);
        throw error;
      }

      if (data?.error) {
        const msg = data.details ? `${data.error}: ${data.details}` : data.error;
        throw new Error(msg);
      }

      return data;
    } catch (error) {
      console.error('ensureClientPortalUser error', error);
      throw error;
    }
  }

  static async resetClientPortalPassword(clientId, password) {
    if (!clientId) throw new Error('Client ID is required');
    try {
      const { data, error } = await supabase.functions.invoke('client-portal-user', {
        body: {
          action: 'reset-password',
          clientId,
          password: password || undefined
        }
      });

      if (error) {
        console.error('resetClientPortalPassword invoke error', error);
        throw error;
      }

      if (data?.error) {
        const msg = data.details ? `${data.error}: ${data.details}` : data.error;
        throw new Error(msg);
      }

      return data;
    } catch (error) {
      console.error('resetClientPortalPassword error', error);
      throw error;
    }
  }
}
